import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreRouterConnectingModule } from '@ngrx/router-store'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { StoreDevtoolsModule } from '@ngrx/store-devtools'
import { NzModalModule } from 'ng-zorro-antd/modal'
import { TranslateModule } from '@ngx-translate/core'
import { GlobalEffects } from '@adex/store/effects/global.effects'
import { NotificationsEffects } from '@adex/store/effects/notifications.effects'
import { AuthEffects } from '@adex/store/effects/auth.effects'
import { metaReducers, reducers } from '@adex/store/reducers'
import { environment } from '../../environments'
import { NotificationNetworkService } from './services/notification-network.service'
import { AuthNetworkService } from './services/auth-network.service'
import { FinanceEffects } from './effects/finance.effects'
import { FinanceNetworkService } from '@adex/store/services/finance-network.service'
import { ClipboardModule } from 'ngx-clipboard'
import { CookieService } from 'ngx-cookie-service'


const effects = [
  GlobalEffects,
  NotificationsEffects,
  AuthEffects,
  FinanceEffects
]

const imports = []

if (!environment.production) {
  imports.push(StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production, name: 'adex' }))
}


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NzModalModule,
    TranslateModule,
    ClipboardModule,
    StoreRouterConnectingModule.forRoot(),
    EffectsModule.forRoot([ ...effects ]),
    StoreModule.forRoot(reducers, { metaReducers }),
    ...imports
  ],
  providers: [
    NotificationNetworkService,
    AuthNetworkService,
    FinanceNetworkService,
    CookieService
  ]
})
export class GlobalStoreModule {
}
